import { ReactNode } from 'react';
import IconLock from '@creditflowresearch/uilib/Icon/IconLock';
import pageTopSectionStyles from '@/creditflowresearch/ui/common/components/templates/PageTopSection/pageTopSection.module.scss';

interface ILockIconProps {
  children: ReactNode,
}

const LockIcon = ({ children }: ILockIconProps) => (
  <>
    <IconLock className={ pageTopSectionStyles.lockIcon } />
    { children }
  </>
);

export default LockIcon;
